import {Button, Divider, Empty, Grid, Spin} from "antd";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import {TeamLogo} from "../../SecurityTeam/components/TeamLogo";
import {useEffect, useMemo} from "react";
import {MemberTable} from "./components/MemberTable";
import {Members} from "../../SecurityTeam/components/Members";
import {Tabs} from "../../../components/Tabs";
import {useQuery} from "react-query";
import {getPersonalInfo} from "../../../api/User";
import {getSecurityTeamDetail, getTeamDetail} from "../../../api/Team";
import MarkdownIt from "markdown-it";
import {TeamItem} from "../../SecurityTeam/components/TeamItem";

const {useBreakpoint} = Grid
const mdParser = new MarkdownIt();

const ApplyBtn = styled(Button)`
  background-color: #18EAC4;
  color: #000000;
  border-color: #18EAC4;
  border-radius: 4px;
  &:hover {
    background-color: #18EAC4;
    color: #000000;
  }
`

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
`

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 24px;
  margin-left: 23px;
  flex: 1;
  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
  > div {
    font-weight: normal;
    font-size: 14px;
    margin-top: 5px;
    @media screen and (max-width: 768px) {
      color: #4B555E;
      font-size: 12px;
      line-height: 15px;
    }
  }
`

const Wrapper = styled.div`
  z-index: 1;
  width: 100%;
  padding: 33px 47px;
`

const Desc = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 24px;
`

const TabContent = styled.div`
  position: relative;
`

const TotalScore = styled.div`
  position: absolute;
  top: 12px;
  right: 0;
  font-size: 14px;
  color: #00eec2;
  font-weight: bold;
`

const NotJoined = () => {
    const navigate = useNavigate()
    return (
        <Empty
            image={null}
            description={<span>You haven't joined any team yet, go apply.</span>}>
            <ApplyBtn type="primary" onClick={() => navigate('/whitehat-teams')}>Go Apply</ApplyBtn>
        </Empty>
    )
}

export const Team = () => {
    const breakpoint = useBreakpoint();

    const isMobile = useMemo(() => {
        return breakpoint.xs || (breakpoint.sm && !breakpoint.md)
    }, [breakpoint])

    const {data: userInfo} = useQuery('userinfo', () => getPersonalInfo())

    const {data: teamDetailData} = useQuery('team_detail', () => getSecurityTeamDetail(userInfo?.data.security_member?.security_team.title), {
        enabled: !!userInfo?.data.security_member?.security_team_id
    })

    const teamDetail = useMemo(() => teamDetailData?.data ?? {}, [teamDetailData])

    const memberStatus = useMemo(() => userInfo?.data?.security_member?.is_manager ?? 0, [userInfo])

    const tabItems = [{
        label: 'Detail',
        key: '1',
        children: (
            <Desc>
                <div className='custom-html-style' dangerouslySetInnerHTML={{__html: mdParser.render(teamDetail?.description ?? '')}} />
            </Desc>
        )
    }, {
        label: 'Members',
        key: '2',
        children: (
            <MemberTable title={teamDetail.title} type={memberStatus} />
        )
    }]

    if (!userInfo?.data.security_member?.security_team_id) {
        return (
            <Spin spinning={!userInfo}>
                <NotJoined />
            </Spin>
        )
    }

    if (userInfo?.data.member_status === 0) {
        return (
            <Spin spinning={!teamDetail.cover_file}>
                <TeamItem team={teamDetail} userMemberStatus={userInfo?.data.member_status} key={teamDetail?.title} />
            </Spin>
        )
    }

    return (
        <Wrapper>
            <Spin spinning={!teamDetail.cover_file}>
                <TitleWrap>
                    <TeamLogo size={isMobile ? 64 : 89} logo={teamDetail.logo_file} />
                    <Title>
                        {teamDetail.title}
                        <div>{teamDetail.summary}</div>
                    </Title>
                </TitleWrap>
                <Divider />
                <TabContent>
                    <TotalScore>
                        Total Score: {teamDetail.total_score ?? 0}
                    </TotalScore>
                    <Tabs items={tabItems} />
                </TabContent>
            </Spin>
        </Wrapper>
    )
}
